import { render } from "./DocManagement.vue?vue&type=template&id=0dcf0eee"
import script from "./DocManagement.vue?vue&type=script&lang=js"
export * from "./DocManagement.vue?vue&type=script&lang=js"

import "./DocManagement.vue?vue&type=style&index=0&id=0dcf0eee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__